const getDefaultAuthUser = () => ({
  id: null,
  fullName: null,
  isSuperAdmin: null,
  isAdministrator: null,
  isSalesPerson: null,
  xsrfCookieKey: null,
  customerHasContent: null,
  customerHasSas: null
});

const state = () => ({
  authUser: getDefaultAuthUser(),
  isLoggedIn: false,
  modalErrorMessage: "",
  hasModalError: false
});

const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn;
  }
};

const actions = {};

const mutations = {
  resetModalError(state) {
    state.modalErrorMessage = "";
  },

  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  setAuthUser(state, user) {
    if (user) {
      state.authUser.id = user.id;
      state.authUser.fullName = user.fullName;
      state.authUser.isSuperAdmin = user.isSuperAdmin;
      state.authUser.isAdministrator = user.isAdministrator;
      state.authUser.isSalesPerson = user.isSalesPerson;
      state.authUser.xsrfCookieKey = user.xsrfCookieKey;
      localStorage.setItem("xsrf-cookie-key", user.xsrfCookieKey);
      state.authUser.customerHasContent = user.customerHasContent;
      state.authUser.customerHasSas = user.customerHasSas;
    } else state.authUser = getDefaultAuthUser();

    state.isLoggedIn = user !== null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
